// extracted by mini-css-extract-plugin
export default {"ellipsis":"IiE3qqW7iSzos0XFKGE2","wrapper":"ypKIzIYTlMKWNvxi2hc9","content":"cFPRuhViEuBdxZWEISEB","spin":"e_hSEkhdi0UeCJFqKKeO"};